<template>
  <div class="body__form--subscription">
    <div class="subscription__section">
      <div class="hide__subscription-section">
        <div class="card">
          <div class="card-body">
            <div class="step__voyage">
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="
                    step === 1 || step === 2 ? 'custom__badge--active' : ''
                  "
                >
                  1
                </div>
                <div
                  class="badge__text"
                  :class="step === 1 || step === 2 ? 'badge__text--active' : ''"
                >
                  Informations
                </div>
              </div>
              <hr />
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="step === 3 ? 'custom__badge--active' : ''"
                >
                  2
                </div>
                <div
                  class="badge__text"
                  :class="step === 3 ? 'badge__text--active' : ''"
                >
                  Fichiers joints
                </div>
              </div>
              <hr />
              <div class="step__voyage--item">
                <div
                  class="custom__badge_default"
                  :class="step === 4 ? 'custom__badge--active' : ''"
                >
                  3
                </div>
                <div
                  class="badge__text"
                  :class="step === 4 ? 'badge__text--active' : ''"
                >
                  Résultat
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="card">
          <div class="card-body">
            <div class="custom__badge-section d-md-none">
              <div
                class="custom__badge_default"
                :class="step === 1 || step === 2 ? 'custom__badge--active' : ''"
              >
                1
              </div>
              <div
                class="custom__badge_default"
                :class="step === 3 ? 'custom__badge--active' : ''"
              >
                2
              </div>
              <div
                class="custom__badge_default"
                :class="step === 4 ? 'custom__badge--active' : ''"
              >
                3
              </div>
            </div>

            <div v-if="step === 1">
              <h4 class="mb-4">{{ titleStep() }}</h4>

              <div class="row mb-3">
                <div class="col-12">
                  <div class="type-tabs">
                    <button
                      class="type-tab"
                      :class="{ active: form.data.type_engin === '1' }"
                      @click="setTypeEngin('1')"
                    >
                      <i class="fas fa-car"></i>
                      <span>Véhicules à 4 roues</span>
                    </button>
                    <button
                      class="type-tab"
                      :class="{ active: form.data.type_engin === '2' }"
                      @click="setTypeEngin('2')"
                    >
                      <i class="fas fa-motorcycle"></i>
                      <span>2 ou 3 roues</span>
                    </button>
                  </div>
                  <div v-if="errors.type_engin" class="text-danger mt-1">
                    {{ errors.type_engin[0] }}
                  </div>
                </div>
              </div>

              <div v-if="['2', '3'].includes(node)">
                <h4 class="mb-4">Informations clients</h4>
                <div class="form-row">
                  <div class="col-md-6 col-12">
                    <div class="form-group">
                      <label class="form__label">Nom du client</label>
                      <span class="required">*</span>
                      <input
                        v-model="form.data.client_name"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.client_name }"
                        @input="clearFieldError('client_name')"
                      />
                      <div v-if="errors.client_name" class="invalid-feedback">
                        {{ errors.client_name[0] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="form-group">
                      <label class="form__label">Prénom(s) du client</label>
                      <span class="required">*</span>
                      <input
                        v-model="form.data.client_firstname"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': errors.client_firstname }"
                        @input="clearFieldError('client_firstname')"
                      />
                      <div
                        v-if="errors.client_firstname"
                        class="invalid-feedback"
                      >
                        {{ errors.client_firstname[0] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="form-group">
                      <label class="form__label">Numéro de téléphone</label>
                      <span class="required">*</span>
                      <input
                        v-model="form.data.client_phone"
                        type="number"
                        min="0"
                        class="form-control"
                        :class="{ 'is-invalid': errors.client_phone }"
                        @input="clearFieldError('client_phone')"
                      />
                      <div v-if="errors.client_phone" class="invalid-feedback">
                        {{ errors.client_phone[0] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="form-group">
                      <label class="form__label">Email</label>
                      <input
                        v-model="form.data.client_email"
                        type="email"
                        class="form-control"
                        :class="{ 'is-invalid': errors.client_email }"
                        @input="clearFieldError('client_email')"
                      />
                      <div v-if="errors.client_email" class="invalid-feedback">
                        {{ errors.client_email[0] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2" v-if="auth.profile == 2">
                <div class="col-md-12 col-12">
                  <div class="form-group">
                    <label class="form__label">Intermédiaire associé</label>
                    <select
                      v-model="form.data.sale_code"
                      class="form-control"
                      @change="getSalePoint()"
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in intermediaires"
                        :key="key"
                        :value="item.sale_code"
                      >
                        {{
                          item.nom_entreprise
                            ? item.nom_entreprise
                            : item.last_name + " " + item.first_name
                        }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <template v-if="form.data.type_engin === '1'">
                <div class="row mt-2">
                  <div class="col-md-6 col-12">
                    <div class="form-group">
                      <label class="form__label">Type de carburant</label>
                      <span class="required">*</span>
                      <select
                        v-model="form.data.fuel_id"
                        class="form-control"
                        :class="{ 'is-invalid': errors.fuel_id }"
                        @change="
                          clearFieldError('fuel_id');
                          onFuelChange();
                        "
                      >
                        <option value="">Selectionner</option>
                        <option
                          v-for="(item, key) in typeCarburant"
                          :key="key"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <div v-if="errors.fuel_id" class="invalid-feedback">
                        {{ errors.fuel_id[0] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="form-group">
                      <label class="form__label">Puissance en chevaux</label>
                      <span class="required">*</span>
                      <select
                        v-model="form.data.power_id"
                        class="form-control"
                        :class="{ 'is-invalid': errors.power_id }"
                        @change="
                          clearFieldError('power_id');
                          onFieldChange('power_id');
                        "
                      >
                        <option value="">Selectionner</option>
                        <option
                          v-for="(item, key) in puissance"
                          :key="key"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <div v-if="errors.power_id" class="invalid-feedback">
                        {{ errors.power_id[0] }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-md-6 col-12">
                    <div class="form-group">
                      <label class="form__label">Catégorie / Usage</label>
                      <span class="required">*</span>
                      <select
                        v-model="form.data.category_id"
                        class="form-control"
                        :class="{ 'is-invalid': errors.category_id }"
                        @change="
                          clearFieldError('category_id');
                          onCategoryChange();
                        "
                      >
                        <option value="">Selectionner</option>
                        <option
                          v-for="(item, key) in categories"
                          :key="key"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <div v-if="errors.category_id" class="invalid-feedback">
                        {{ errors.category_id[0] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="form-group">
                      <label class="form__label">Sous catégorie</label>
                      <span class="required">*</span>
                      <select
                        v-model="form.data.sub_category_id"
                        class="form-control"
                        :class="{ 'is-invalid': errors.sub_category_id }"
                        @change="
                          clearFieldError('sub_category_id');
                          onSubCategoryChange();
                        "
                      >
                        <option value="">Selectionner</option>
                        <option
                          v-for="(item, key) in sub_categories"
                          :key="key"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <div
                        v-if="errors.sub_category_id"
                        class="invalid-feedback"
                      >
                        {{ errors.sub_category_id[0] }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <template v-if="form.data.type_engin === '2'">
                <div class="row mt-2">
                  <div class="col-md-6 col-12">
                    <div class="form-group">
                      <label class="form__label">Catégorie / Usage</label>
                      <span class="required">*</span>
                      <select
                        v-model="form.data.category_id"
                        class="form-control"
                        :class="{ 'is-invalid': errors.category_id }"
                        @change="
                          clearFieldError('category_id');
                          onMotoCategoryChange();
                        "
                      >
                        <option value="">Selectionner</option>
                        <option
                          v-for="(item, key) in categories"
                          :key="key"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <div v-if="errors.category_id" class="invalid-feedback">
                        {{ errors.category_id[0] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="form-group">
                      <label class="form__label">Cylindrée (cm³)</label>
                      <span class="required">*</span>
                      <select
                        v-model="form.data.power_id"
                        class="form-control"
                        :class="{ 'is-invalid': errors.power_id }"
                        @change="
                          clearFieldError('power_id');
                          onFieldChange('power_id');
                        "
                      >
                        <option value="">Selectionner</option>
                        <option
                          v-for="(item, key) in puissance"
                          :key="key"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <div v-if="errors.power_id" class="invalid-feedback">
                        {{ errors.power_id[0] }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-md-6 col-12">
                    <div class="form-group">
                      <label class="form__label">Valeur Vénale</label>
                      <span class="required">*</span>
                      <input
                        v-model="form.data.valeur_venal"
                        type="number"
                        min="0"
                        class="form-control"
                        :class="{ 'is-invalid': errors.valeur_venal }"
                        @input="
                          clearFieldError('valeur_venal');
                          onFieldChange('valeur_venal');
                        "
                      />
                      <div v-if="errors.valeur_venal" class="invalid-feedback">
                        {{ errors.valeur_venal[0] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="form-group">
                      <label class="form__label">Valeur Neuve</label>
                      <span class="required">*</span>
                      <input
                        v-model="form.data.valeur_neuve"
                        type="number"
                        min="0"
                        class="form-control"
                        :class="{ 'is-invalid': errors.valeur_neuve }"
                        @input="
                          clearFieldError('valeur_neuve');
                          onFieldChange('valeur_neuve');
                        "
                      />
                      <div v-if="errors.valeur_neuve" class="invalid-feedback">
                        {{ errors.valeur_neuve[0] }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <div class="row mt-2">
                <div
                  :class="`col-md-${
                    form.data.type_engin === '2'
                      ? '6'
                      : form.data.duration_of_insurance == '6 month' &&
                        form.data.category_id == 4
                      ? '4'
                      : '6'
                  } col-12`"
                >
                  <div class="form-group">
                    <label class="form__label">Nombre de places</label>
                    <span class="required">*</span>
                    <input
                      v-model="form.data.number_of_seats"
                      type="number"
                      min="0"
                      class="form-control"
                      :class="{
                        'is-invalid': errors.number_of_seats,
                      }"
                      @input="
                        clearFieldError('number_of_seats');
                        onFieldChange('number_of_seats');
                      "
                    />
                    <div v-if="errors.number_of_seats" class="invalid-feedback">
                      {{ errors.number_of_seats[0] }}
                    </div>
                  </div>
                </div>

                <div
                  v-if="form.data.type_engin !== '2'"
                  :class="`col-md-${
                    form.data.duration_of_insurance == '6 month' &&
                    form.data.category_id == 4
                      ? '4'
                      : '6'
                  } col-12`"
                >
                  <div class="form-group">
                    <label class="form__label">Durée de l'abonnement</label>
                    <span class="required">*</span>
                    <select
                      v-model="form.data.duration_of_insurance"
                      class="form-control"
                      :class="{ 'is-invalid': errors.duration_of_insurance }"
                      @change="
                        clearFieldError('duration_of_insurance');
                        onFieldChange('duration_of_insurance');
                      "
                    >
                      <option value="">Selectionner</option>
                      <option
                        v-for="(item, key) in durations"
                        :key="key"
                        :value="item.slug"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                    <div
                      v-if="errors.duration_of_insurance"
                      class="invalid-feedback"
                    >
                      {{ errors.duration_of_insurance[0] }}
                    </div>
                  </div>
                </div>

                <div
                  v-if="form.data.type_engin === '2'"
                  class="col-md-6 col-12"
                >
                  <div class="form-group">
                    <label class="form__label">Durée de l'abonnement</label>
                    <span class="required">*</span>
                    <input
                      type="text"
                      class="form-control"
                      value="1 an"
                      disabled
                    />
                    <small class="text-muted"
                      >Durée fixe pour les 2/3 roues</small
                    >
                  </div>
                </div>

                <div
                  class="col-md-4 col-12"
                  v-if="
                    form.data.type_engin !== '2' &&
                    form.data.category_id == 4 &&
                    form.data.duration_of_insurance === '6 month'
                  "
                >
                  <div class="form-group">
                    <label class="form__label">1er 6 mois ?</label>
                    <span class="required">*</span>
                    <div class="form-check mt-2">
                      <label class="form-check-label form__label">
                        <input
                          v-model="form.data.first_six_month"
                          :value="true"
                          type="radio"
                          class="form-check-input"
                          name="first_six_month"
                          @change="
                            clearFieldError('first_six_month');
                            onFieldChange('first_six_month');
                          "
                        />Oui
                      </label>
                      <label class="form-check-label form__label ml-5">
                        <input
                          v-model="form.data.first_six_month"
                          :value="false"
                          type="radio"
                          class="form-check-input"
                          name="first_six_month"
                          @change="
                            clearFieldError('first_six_month');
                            onFieldChange('first_six_month');
                          "
                        />Non
                      </label>
                    </div>
                    <div v-if="errors.first_six_month" class="invalid-feedback">
                      {{ errors.first_six_month[0] }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2" v-if="form.data.type_engin === '1'">
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Valeur Vénale</label>
                    <span class="required">*</span>
                    <input
                      v-model="form.data.valeur_venal"
                      type="number"
                      min="0"
                      class="form-control"
                      :class="{ 'is-invalid': errors.valeur_venal }"
                      @input="
                        clearFieldError('valeur_venal');
                        onFieldChange('valeur_venal');
                      "
                    />
                    <div v-if="errors.valeur_venal" class="invalid-feedback">
                      {{ errors.valeur_venal[0] }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="form-group">
                    <label class="form__label">Valeur Neuve</label>
                    <span class="required">*</span>
                    <input
                      v-model="form.data.valeur_neuve"
                      type="number"
                      min="0"
                      class="form-control"
                      :class="{ 'is-invalid': errors.valeur_neuve }"
                      @input="
                        clearFieldError('valeur_neuve');
                        onFieldChange('valeur_neuve');
                      "
                    />
                    <div v-if="errors.valeur_neuve" class="invalid-feedback">
                      {{ errors.valeur_neuve[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="step === 2">
              <h4 class="mb-4">{{ titleStep() }}</h4>

              <div v-if="surprimeList.length > 0" class="row">
                <div class="col-12">
                  <h6 class="font-weight-bold">
                    Surprime responsabilité civile
                  </h6>
                </div>
              </div>

              <div
                class="row mb-2"
                v-for="(item, index) in surprimeList"
                :key="'surprime_' + index"
              >
                <div class="col-12">
                  <div class="surprime__section">
                    <div class="surprime__section-first">
                      <input
                        type="checkbox"
                        :id="'surprime_' + index"
                        :checked="item.checked || item.required"
                        @change="toggleSurprime(item, index)"
                        :disabled="item.required"
                      />
                      <label :for="'surprime_' + index" class="form__label">{{
                        item.text
                      }}</label>
                      <svg
                        style="cursor: pointer"
                        @click="showTooltips(item.text)"
                        class="tooltips_n"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.49935 2.07247C5.18564 2.07247 2.49935 4.75876 2.49935 8.07247C2.49935 11.3862 5.18564 14.0725 8.49935 14.0725C11.8131 14.0725 14.4993 11.3862 14.4993 8.07247C14.4993 4.75876 11.8131 2.07247 8.49935 2.07247ZM1.16602 8.07247C1.16602 4.02238 4.44926 0.739136 8.49935 0.739136C12.5494 0.739136 15.8327 4.02238 15.8327 8.07247C15.8327 12.1226 12.5494 15.4058 8.49935 15.4058C4.44926 15.4058 1.16602 12.1226 1.16602 8.07247Z"
                            fill="#5E5873"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8.49935 7.4058C8.86754 7.4058 9.16602 7.70428 9.16602 8.07247V10.7391C9.16602 11.1073 8.86754 11.4058 8.49935 11.4058C8.13116 11.4058 7.83268 11.1073 7.83268 10.7391V8.07247C7.83268 7.70428 8.13116 7.4058 8.49935 7.4058Z"
                            fill="#5E5873"
                          />
                          <path
                            d="M9.16602 5.4058C9.16602 5.77399 8.86754 6.07247 8.49935 6.07247C8.13116 6.07247 7.83268 5.77399 7.83268 5.4058C7.83268 5.03761 8.13116 4.73914 8.49935 4.73914C8.86754 4.73914 9.16602 5.03761 9.16602 5.4058Z"
                            fill="#5E5873"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect
                              width="16"
                              height="16"
                              fill="white"
                              transform="translate(0.5 0.0725098)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <div class="surprime__section-two"></div>
                    <div class="surprime__section-tree">
                      {{ formatPrice(item.display_amount || item.coast || 0) }}
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="guarantees.length > 0" class="row">
                <div class="col-12">
                  <h6 class="font-weight-bold">Garanties</h6>
                </div>
              </div>
              <div
                class="row mb-2 guarantee-item"
                v-for="(item, key) in guarantees"
                :key="'guarantee_' + item.id"
                :class="{
                  'has-impact': item.is_impacted,
                  impacted: item.is_impacted,
                }"
              >
                <div class="col-12">
                  <div class="surprime__section">
                    <div class="surprime__section-first">
                      <div class="checkbox-wrapper">
                        <input
                          type="checkbox"
                          :id="'guarantee_' + item.id"
                          :disabled="getGuaranteeState(item).disabled"
                          :checked="getGuaranteeState(item).checked"
                          @change="handleGuaranteeToggle(item, key)"
                        />
                        <label
                          :for="'guarantee_' + item.id"
                          class="form__label"
                        >
                          {{ item.name }}
                          <span
                            v-if="getGuaranteeState(item).isDefault"
                            class="badge badge-warning ml-2"
                            >Inclus</span
                          >
                        </label>
                      </div>
                    </div>
                    <div class="surprime__section-two"></div>
                    <div class="surprime__section-tree">
                      <span v-if="item.is_impacted">
                        {{ formatPrice(item.amount) }}
                        <small
                          class="text-muted"
                          style="font-size: 10px; text-decoration: line-through"
                        >
                          {{ formatPrice(item.original_amount) }}
                        </small>
                      </span>
                      <span v-else-if="item.amount > 0">
                        {{ formatPrice(item.amount) }}
                      </span>
                      <span v-else-if="item.amount === 0 && item.is_mandatory">
                        Inclus
                      </span>
                      <span v-else-if="item.amount === 0"> 0 FCFA </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="step === 3">
              <h4 class="mb-4">{{ titleStep() }}</h4>
              <p>
                Veuillez charger le(s) fichier(s) requis :
                <span style="color: #d09a12">copie de la carte grise.</span>
              </p>
              <file-upload
                ref="upload"
                :acceptFile="'.jpg,.png,.gif,.jpeg,.pdf,.doc,.docx,.xls,.xlsx'"
              />
            </div>
            <div v-if="step === 4">
              <h4 class="mb-4">{{ titleStep() }}</h4>

              <div
                class="text-sm mb-2"
                v-if="
                  (auth.profile === 3 || auth.profile === 2) &&
                  form.data.type_engin === '1'
                "
              >
                Pour offrir une réduction au client entrez, le pourcentage de
                réduction dans le champ ci-dessous puis validez
              </div>

              <div class="detail__sup">
                <div
                  class="reduction-section"
                  v-if="
                    (auth.profile === 3 || auth.profile === 2) &&
                    form.data.type_engin === '1'
                  "
                >
                  <div class="reduction-input-group">
                    <input
                      type="number"
                      min="1"
                      class="form-control form-control-sm reduction-input"
                      placeholder="% de réduction"
                      v-model="reductionPercentage"
                      @input="onReductionInput"
                      :disabled="hasReduction"
                    />
                    <div class="reduction-buttons">
                      <button
                        class="btn btn-primary btn-sm btn-reduction"
                        @click="applyReduction"
                        :disabled="
                          hasReduction ||
                          isApplyingReduction ||
                          !reductionPercentage ||
                          reductionPercentage <= 0
                        "
                      >
                        Appliquer
                      </button>
                      <button
                        v-if="hasReduction"
                        class="btn btn-outline-danger btn-sm btn-reduction-cancel"
                        @click="cancelReduction"
                        :disabled="isApplyingReduction"
                      >
                        Annuler
                      </button>
                    </div>
                  </div>
                </div>

                <div class="section__information mt-2">
                  <div class="section__information-text">Prime Nette</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ formatPrice(summary.net_premium || 0) }}
                  </div>
                </div>

                <div class="section__information mt-1">
                  <div class="section__information-text">Taxes</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ formatPrice(summary.tax || 0) }}
                  </div>
                </div>

                <div class="section__information mt-3">
                  <div class="section__information-text">Accessoires</div>
                  <div class="section__information-dote"></div>
                  <div class="section__information-price">
                    {{ formatPrice(summary.avenant) }}
                  </div>
                </div>

                <div
                  class="section__amount d-flex justify-content-between mt-3 pt-2 border-top"
                >
                  <div class="section__amount-text h5">Total à payer</div>
                  <div
                    class="section__amount-price h5 font-weight-bold"
                    style="color: #ea5455"
                  >
                    {{ formatPrice(summary.total || 0) }}
                  </div>
                </div>

                <div
                  v-if="hasReduction && form.data.type_engin === '1'"
                  class="text-success mt-2"
                >
                  <small
                    >Réduction de {{ form.per || reductionPercentage }}%
                    appliquée</small
                  >
                </div>
              </div>

              <div
                class="section__neg"
                v-if="node == '0'"
                @click="saveNegotiated()"
              >
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.50065 2.57255C5.35851 2.57255 2.00065 5.93041 2.00065 10.0725C2.00065 14.2147 5.35851 17.5725 9.50065 17.5725C13.6428 17.5725 17.0006 14.2147 17.0006 10.0725C17.0006 5.93041 13.6428 2.57255 9.50065 2.57255ZM0.333984 10.0725C0.333984 5.00994 4.43804 0.905884 9.50065 0.905884C14.5633 0.905884 18.6673 5.00994 18.6673 10.0725C18.6673 15.1352 14.5633 19.2392 9.50065 19.2392C4.43804 19.2392 0.333984 15.1352 0.333984 10.0725Z"
                    fill="#002A85"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.50065 9.23922C9.96089 9.23922 10.334 9.61231 10.334 10.0725V13.4059C10.334 13.8661 9.96089 14.2392 9.50065 14.2392C9.04041 14.2392 8.66732 13.8661 8.66732 13.4059V10.0725C8.66732 9.61231 9.04041 9.23922 9.50065 9.23922Z"
                    fill="#002A85"
                  />
                  <path
                    d="M10.334 6.73922C10.334 7.19945 9.96089 7.57255 9.50065 7.57255C9.04041 7.57255 8.66732 7.19945 9.50065 6.73922C8.66732 6.27898 9.04041 5.90588 9.50065 6.73922Z"
                    fill="#002A85"
                  />
                </svg>
                <span class="section__neg-text">Demander une négociation</span>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="button__footer">
              <button
                @click="prevStep"
                :disabled="step === 1"
                class="btn btn-default__cancel mr-2"
              >
                Retour
              </button>
              <button
                class="btn btn-primary__save"
                @click="saveAssurance"
                :disabled="isLoading"
              >
                {{ getButtonText() }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="comments"
      tabindex="-1"
      role="dialog"
      aria-labelledby="comments"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header" style="background-color: #fff !important">
            <h5 class="modal-title" id="comments">
              Négociation de l'assurance auto n° {{ id }}
            </h5>
            <button
              type="button"
              class="close"
              @click="closeModal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="background-color: #f8f8f8 !important">
            <div class="chat-box">
              <div
                :class="!comment.is_customer ? 'chat' : 'chat-left'"
                class="mb-2"
                v-for="(comment, key) in comments"
                :key="key"
              >
                {{ comment.message }}
              </div>
            </div>
          </div>
          <div class="modal-footer grid-item">
            <input
              @keyup.enter="sendComment"
              v-model="comment.message"
              type="text"
              class="form-control message"
              placeholder="Tapez votre message"
            />
            <button @click="sendComment" type="button" class="btn btn-primary">
              Envoyer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { api } from "../../../helpers/shared";
import FileUpload from "../../../components/upload/FileUpload.vue";
import GarantiesManager from "../../../managers/garantiesManager.js";

export default {
  name: "AutoInsurance",
  components: { FileUpload },
  props: ["node"],
  data() {
    return {
      step: 1,
      isLoading: false,
      isApplyingReduction: false,
      hasReduction: false,
      reductionPercentage: "",
      errors: {},
      auth: {},
      intermediaires: [],
      garantiesManager: null,
      selectedGuarantees: [],
      form: {
        amount: "",
        amount_before_reduce: "",
        per: "",
        product_id: 1,
        step: 1,
        data: {
          client_name: "",
          client_firstname: "",
          client_phone: "",
          client_email: "",
          type_engin: "1",
          fuel_id: "",
          power_id: "",
          sale_code: "",
          sale_point: "",
          category_id: "",
          sub_category_id: "",
          use_type: "",
          semi_remorque: false,
          domage: false,
          first_six_month: "",
          duration_of_insurance: "",
          number_of_seats: "",
          pourcentage_reduction: "",
          originalPrc: 0,
          valeur_venal: "",
          valeur_neuve: "",
          list_of_guarantees: [],
          contain_cedeao: false,
        },
      },
      categories: [],
      sub_categories: [],
      durations: [],
      puissance: [],
      typeCarburant: [
        { name: "Essence", id: 1 },
        { name: "Diesel", id: 2 },
      ],
      guarantees: [],
      surprimeList: [],
      files: [],
      guaranteesSummary: [],
      avenantsList: [],
      breakdown: null,
      summary: {
        net_premium: 0,
        rc_amount: 0,
        rc_amount_original: 0,
        guarantees_price: 0,
        cedeao: 0,
        avenant: 0,
        police_fees: 0,
        tax_rate: 0,
        tax: 0,
        total: 0,
        reduction: 0,
        garanties: 0,
      },
      comment: { message: "", uuid: "", id: "" },
      comments: [],
      uuid: "",
      id: "",
      debounceTimer: null,
    };
  },
  watch: {
    // ✅ WATCH: Nombre de places → calcul automatique de la surprime
    "form.data.number_of_seats": function (newVal) {
      if (newVal && (this.form.data.sub_category_id || this.form.data.category_id)) {
        this.loadSurprime();
        if (this.isValidForCalculation()) {
          this.calculatePremium();
        }
      }
    },
    "form.data.sub_category_id": function (newVal) {
      if (newVal && this.form.data.number_of_seats) {
        this.loadSurprime();
      }
    },
    "form.data.type_engin": function () {
      this.resetForm();
    },
    step: function (val) {
      this.form.step = val;
      if (val === 4) {
        this.calculatePremium();
      }
    },
    reductionPercentage(newValue) {
      if (
        newValue &&
        newValue.toString().startsWith("0") &&
        newValue.toString().length > 1
      ) {
        this.reductionPercentage = newValue.toString().replace(/^0+/, "");
      }
    },
  },
  mounted() {
    this.auth = JSON.parse(localStorage.getItem("auth"))?.user || {};
    this.loadInitialData();
  },
  methods: {
    // ============================================
    // FORMATAGE
    // ============================================
    formatPrice(value) {
      if (!value && value !== 0) return "0 FCFA";
      return `${Number(value).toLocaleString("fr-FR")} FCFA`;
    },

    // ============================================
    // RÉINITIALISATION DU FORMULAIRE
    // ============================================
    resetForm() {
      const typeEngin = this.form.data.type_engin;
      
      // Réinitialiser toutes les données sauf le type d'engin
      this.form.data = {
        client_name: "",
        client_firstname: "",
        client_phone: "",
        client_email: "",
        type_engin: typeEngin,
        fuel_id: "",
        power_id: "",
        sale_code: "",
        sale_point: "",
        category_id: "",
        sub_category_id: "",
        use_type: "",
        semi_remorque: false,
        domage: false,
        first_six_month: "",
        duration_of_insurance: "",
        number_of_seats: "",
        pourcentage_reduction: "",
        originalPrc: 0,
        valeur_venal: "",
        valeur_neuve: "",
        list_of_guarantees: [],
        contain_cedeao: false,
      };
      
      // Réinitialiser les listes
      this.categories = [];
      this.sub_categories = [];
      this.guarantees = [];
      this.surprimeList = [];
      this.puissance = [];
      this.errors = {};
      
      // Réinitialiser le résumé
      this.summary = {
        net_premium: 0,
        rc_amount: 0,
        rc_amount_original: 0,
        guarantees_price: 0,
        cedeao: 0,
        avenant: 0,
        police_fees: 0,
        tax_rate: 0,
        tax: 0,
        total: 0,
        reduction: 0,
        garanties: 0,
      };
      
      // Réinitialiser les réductions
      this.hasReduction = false;
      this.reductionPercentage = "";
      this.isApplyingReduction = false;
      this.form.per = "";
      
      // Si c'est un 2/3 roues, forcer la durée
      if (typeEngin === "2") {
        this.form.data.duration_of_insurance = "1 year";
      }
      
      // Recharger les catégories pour le nouveau type
      this.getCategories();
      this.getDurations();
    },

    // ============================================
    // VALIDATION
    // ============================================
    clearFieldError(fieldName) {
      if (this.errors[fieldName]) {
        delete this.errors[fieldName];
      }
    },

    validateForm() {
      const errors = {};
      const data = this.form.data;

      if (!data.type_engin) {
        errors.type_engin = ["Le type d'engin est obligatoire"];
      }

      if (data.type_engin === "1" && !data.duration_of_insurance) {
        errors.duration_of_insurance = ["La durée est obligatoire"];
      }

      if (!data.power_id) {
        errors.power_id = ["La puissance est obligatoire"];
      }

      if (!data.number_of_seats) {
        errors.number_of_seats = ["Le nombre de places est obligatoire"];
      }

      if (data.type_engin === "1") {
        if (!data.category_id) {
          errors.category_id = ["La catégorie est obligatoire"];
        }
        if (!data.sub_category_id) {
          errors.sub_category_id = ["La sous-catégorie est obligatoire"];
        }
        if (!data.fuel_id) {
          errors.fuel_id = ["Le carburant est obligatoire"];
        }
        if (!data.valeur_venal) {
          errors.valeur_venal = ["La valeur vénale est obligatoire"];
        }
        if (!data.valeur_neuve) {
          errors.valeur_neuve = ["La valeur neuve est obligatoire"];
        }
      }

      if (data.type_engin === "2") {
        if (!data.category_id) {
          errors.category_id = ["La catégorie est obligatoire"];
        }
        if (!data.valeur_venal) {
          errors.valeur_venal = ["La valeur vénale est obligatoire"];
        }
        if (!data.valeur_neuve) {
          errors.valeur_neuve = ["La valeur neuve est obligatoire"];
        }
      }

      if (this.auth.profile === "2" || this.auth.profile === "3") {
        if (!data.client_name) {
          errors.client_name = ["Le nom est obligatoire"];
        }
        if (!data.client_firstname) {
          errors.client_firstname = ["Le prénom est obligatoire"];
        }
        if (!data.client_phone) {
          errors.client_phone = ["Le téléphone est obligatoire"];
        } else if (data.client_phone.toString().length !== 8) {
          errors.client_phone = ["Le téléphone doit contenir 8 chiffres"];
        }
        if (
          data.client_email &&
          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.client_email)
        ) {
          errors.client_email = ["Email invalide"];
        }
      }

      this.errors = errors;
      return Object.keys(errors).length === 0;
    },

    isValidForCalculation() {
      const data = this.form.data;
      if (!data.duration_of_insurance || !data.type_engin || 
          !data.power_id || !data.number_of_seats) {
        return false;
      }

      if (data.type_engin === "1") {
        return data.valeur_venal && data.valeur_neuve && 
               data.category_id && data.sub_category_id && data.fuel_id;
      }

      if (data.type_engin === "2") {
        return data.category_id && data.valeur_venal && data.valeur_neuve;
      }

      return false;
    },

    formatBackendErrors(backendErrors) {
      const fieldMapping = {
        "data.use_type": "use_type",
        "data.client_name": "client_name",
        "data.client_firstname": "client_firstname",
        "data.client_phone": "client_phone",
        "data.client_email": "client_email",
        "data.category_id": "category_id",
        "data.sub_category_id": "sub_category_id",
        "data.fuel_id": "fuel_id",
        "data.power_id": "power_id",
        "data.valeur_venal": "valeur_venal",
        "data.valeur_neuve": "valeur_neuve",
        "data.duration_of_insurance": "duration_of_insurance",
        "data.number_of_seats": "number_of_seats",
        "data.first_six_month": "first_six_month",
        "data.type_engin": "type_engin",
        "data.pourcentage_reduction": "pourcentage_reduction",
      };
      this.errors = {};
      for (const [key, messages] of Object.entries(backendErrors)) {
        const fieldName = fieldMapping[key] || key.replace("data.", "");
        this.errors[fieldName] = messages;
      }
      const firstError = Object.values(this.errors)[0]?.[0];
      if (firstError) {
        this.$toasted.global.error({ message: firstError });
      }
    },

    // ============================================
    // CHARGEMENT DES DONNÉES
    // ============================================
    async loadInitialData() {
      try {
        await this.getCategories();
        await this.getDurations();
        await this.getIntermediaires();
        // ✅ Reset du formulaire à l'arrivée (garder type_engin)
        this.resetForm();
      } catch (error) {
        console.error("Erreur chargement initial:", error);
      }
    },

    async getCategories() {
      try {
        const response = await axios.post(
          api("assurances/automobile/subscription"),
          { type: this.form.data.type_engin, state: "category" }
        );
        this.categories = response.data || [];
        if (this.form.data.type_engin === "2" && this.form.data.category_id) {
          this.getPuissance();
        }
      } catch (error) {
        console.error("Erreur chargement catégories:", error);
      }
    },

    async getSubcategories() {
      if (!this.form.data.category_id) {
        this.sub_categories = [];
        return;
      }
      try {
        const response = await axios.post(
          api("assurances/automobile/subscription"),
          { category: this.form.data.category_id, state: "sub_category" }
        );
        this.sub_categories = response.data || [];
        this.form.data.sub_category_id = "";
        if (this.sub_categories.length > 0) {
          this.loadSurprime();
        }
      } catch (error) {
        console.error("Erreur chargement sous-catégories:", error);
      }
    },

    async getDurations() {
      try {
        const response = await axios.post(
          api("assurances/automobile/subscription"),
          { state: "duration", categoryId: this.form.data.category_id }
        );
        this.durations = response.data || [];
      } catch (error) {
        console.error("Erreur chargement durées:", error);
      }
    },

    async getPuissance() {
      const slug = this.form.data.type_engin === "2" ? "2-3-roue" : "auto";
      const params = { slug: slug, state: "power" };
      if (this.form.data.type_engin === "1" && this.form.data.fuel_id) {
        params.fuel = this.form.data.fuel_id;
      } else if (
        this.form.data.type_engin === "2" &&
        this.form.data.category_id
      ) {
        params.use = this.form.data.category_id;
      }
      try {
        const response = await axios.post(
          api("assurances/automobile/subscription"),
          params
        );
        this.puissance = response.data || [];
      } catch (error) {
        console.error("Erreur chargement puissances:", error);
        this.puissance = [];
      }
    },

    async getGuarantees() {
      if (!this.form.data.category_id) {
        this.guarantees = [];
        return;
      }
      try {
        const payload = {
          category: this.form.data.category_id,
          state: "garuanted",
          data: {
            category_id: this.form.data.category_id,
            sub_category_id: this.form.data.sub_category_id || null,
            fuel_id: this.form.data.fuel_id || null,
            power_id: this.form.data.power_id || null,
            valeur_venal: this.form.data.valeur_venal || "0",
            valeur_neuve: this.form.data.valeur_neuve || "0",
            duration_of_insurance:
              this.form.data.duration_of_insurance || "1 year",
            number_of_seats: this.form.data.number_of_seats || "0",
            contain_cedeao: this.form.data.contain_cedeao || false,
            type_engin: this.form.data.type_engin || "1",
            use_type: this.form.data.use_type || null,
            first_six_month: this.form.data.first_six_month || null,
            selected_guarantees: this.form.data.list_of_guarantees || [],
          },
        };
        const response = await axios.post(
          api("assurances/automobile/subscription"),
          payload
        );
        if (response.data?.status && response.data?.data) {
          const data = response.data.data;
          this.garantiesManager = new GarantiesManager(data);
          const initialized = this.garantiesManager.initialize();
          this.guarantees = initialized;
          this.selectedGuarantees = this.guarantees
            .filter((g) => g.is_selected)
            .map((g) => g.id);
          this.form.data.list_of_guarantees = [...this.selectedGuarantees];

          if (
            this.form.data.category_id == 7 ||
            this.form.data.category_id == 8
          ) {
            const mandatoryIds = this.garantiesManager.rules.mandatory || [];
            mandatoryIds.forEach((id) => {
              if (!this.form.data.list_of_guarantees.includes(id)) {
                this.form.data.list_of_guarantees.push(id);
              }
            });
          }
        }
      } catch (error) {
        console.error("Erreur chargement garanties:", error);
        this.$toasted.global.error({
          message: "Erreur lors du chargement des garanties",
        });
      }
    },

    async getIntermediaires() {
      try {
        const response = await axios.get(api("intermediaires"));
        this.intermediaires = response.data || [];
      } catch (error) {
        console.error("Erreur chargement intermédiaires:", error);
      }
    },

    // ============================================
    // SURPRIME (calcul automatique)
    // ============================================
    async loadSurprime() {
      const categoryId =
        this.form.data.type_engin === "2"
          ? this.form.data.category_id
          : this.form.data.sub_category_id;

      if (!categoryId) return;
      if (!this.form.data.number_of_seats) return;

      try {
        const response = await axios.post(
          api("assurances/automobile/surprime"),
          {
            number_of_seats: this.form.data.number_of_seats,
            type_engin: this.form.data.type_engin || "1",
            fuel_id: this.form.data.fuel_id,
            power_id: this.form.data.power_id,
            category_id: this.form.data.category_id,
            sub_category_id: this.form.data.sub_category_id,
          }
        );
        if (response.data?.status) {
          this.surprimeList = response.data.data || [];
        }
      } catch (error) {
        console.error("Erreur chargement surprises:", error);
      }
    },

    // ============================================
    // GESTION DES CHANGEMENTS
    // ============================================
    getSalePoint() {
      const intermediaire = this.intermediaires.find(
        (item) => item.sale_code === this.form.data.sale_code
      );
      if (intermediaire) {
        this.form.data.sale_point = intermediaire.nom_entreprise
          ? intermediaire.nom_entreprise
          : `${intermediaire.last_name} ${intermediaire.first_name}`;
      }
    },

    onUseTypeChange() {
      this.form.data.power_id = "";
      this.clearFieldError("use_type");
      this.getPuissance();
    },

    setTypeEngin(value) {
      if (this.form.data.type_engin === value) return;
      this.form.data.type_engin = value;
      this.clearFieldError("type_engin");
      // Le reset se fait via le watcher
    },

    onFuelChange() {
      this.clearFieldError("fuel_id");
      if (this.form.data.type_engin === "1") {
        this.form.data.power_id = "";
        this.getPuissance();
      }
    },

    onCategoryChange() {
      this.clearFieldError("category_id");
      this.form.data.sub_category_id = "";
      this.form.data.list_of_guarantees = [];
      this.guarantees = [];
      this.surprimeList = [];
      this.getSubcategories();
      this.getDurations();
      this.getGuarantees();
    },

    onSubCategoryChange() {
      this.clearFieldError("sub_category_id");
      this.loadSurprime();
    },

    onMotoCategoryChange() {
      this.clearFieldError("category_id");
      this.form.data.sub_category_id = "";
      this.form.data.list_of_guarantees = [];
      this.guarantees = [];
      this.surprimeList = [];
      this.getPuissance();
      this.getGuarantees();
      this.loadSurprime();
    },

    onFieldChange(fieldName) {
      if (fieldName) {
        this.clearFieldError(fieldName);
      }
    },

    // ============================================
    // GARANTIES
    // ============================================
    handleGuaranteeToggle(item, key) {
      if (!this.garantiesManager) return;
      const result = this.garantiesManager.toggleGuarantee(
        item.id,
        this.form.data.list_of_guarantees
      );
      this.form.data.list_of_guarantees = result.newList;
      if (result.impactedGuarantees) {
        this.guarantees = result.impactedGuarantees;
      } else {
        this.$forceUpdate();
      }
    },

    getGuaranteeState(item) {
      if (!this.garantiesManager) {
        return {
          checked: false,
          disabled: false,
          isMandatory: false,
          isDefault: false,
          isDisabled: false,
          isExcluded: false,
          canToggle: false,
        };
      }
      const state = this.garantiesManager.getGuaranteeState(
        item.id,
        this.form.data.list_of_guarantees
      );
      return (
        state || {
          checked: false,
          disabled: false,
          isMandatory: false,
          isDefault: false,
          isDisabled: false,
          isExcluded: false,
          canToggle: false,
        }
      );
    },

    toggleSurprime(item, index) {
      if (item.required) return;
      this.surprimeList[index].checked = !this.surprimeList[index].checked;
      if (item.text.includes("remorque")) {
        this.form.data.semi_remorque = this.surprimeList[index].checked;
      }
    },

    // ============================================
    // CALCUL DE LA PRIME
    // ============================================
    async calculatePremium() {
      if (!this.isValidForCalculation()) return;

      try {
        this.isLoading = true;

        const response = await axios.post(
          api("assurances/automobile/calculate"),
          {
            product_id: 1,
            data: {
              type_engin: this.form.data.type_engin,
              category_id: this.form.data.category_id,
              sub_category_id: this.form.data.sub_category_id || null,
              duration_of_insurance:
                this.form.data.duration_of_insurance || "1 year",
              fuel_id: this.form.data.fuel_id || null,
              power_id: this.form.data.power_id,
              number_of_seats: this.form.data.number_of_seats,
              valeur_venal: this.form.data.valeur_venal || "0",
              valeur_neuve: this.form.data.valeur_neuve || "0",
              list_of_guarantees: this.form.data.list_of_guarantees || [],
              pourcentage_reduction:
                this.form.data.pourcentage_reduction || null,
              sale_code: this.form.data.sale_code || null,
              first_six_month: this.form.data.first_six_month || null,
              contain_cedeao: this.form.data.contain_cedeao || false,
              client_name: this.form.data.client_name || null,
              client_firstname: this.form.data.client_firstname || null,
              client_phone: this.form.data.client_phone || null,
              client_email: this.form.data.client_email || null,
              use_type: this.form.data.use_type || null,
            },
          }
        );

        if (response.data?.status) {
          const data = response.data.data;

          this.summary = {
            net_premium: data.net_premium || 0,
            rc_amount: data.breakdown?.prime_rc || data.rc_amount || 0,
            rc_amount_original:
              data.breakdown?.prime_rc_original ||
              data.rc_amount_original ||
              data.rc_amount ||
              0,
            guarantees_price:
              data.breakdown?.garanties || data.guarantees_price || 0,
            cedeao: data.cedeao || 0,
            avenant: data.avenant || 0,
            police_fees: data.breakdown?.frais_police || data.police_fees || 0,
            tax_rate: data.tax_rate || 0,
            tax: data.tax || 0,
            total: data.total || 0,
            reduction: data.breakdown?.reduction || data.reduction || 0,
            garanties: data.breakdown?.garanties || data.guarantees_price || 0,
          };

          this.breakdown = data.breakdown || null;
          this.form.amount = this.summary.total;

          if (data.prc) {
            this.form.data.prc = data.prc;
          }

          this.hasReduction = (this.summary.reduction || 0) > 0;
          if (this.hasReduction) {
            this.form.per = this.summary.reduction;
            this.reductionPercentage = this.summary.reduction;
          }

          this.errors = {};
          this.$forceUpdate();
        }
      } catch (error) {
        console.error("Erreur calcul prime:", error);
        if (error.response?.status === 422) {
          this.formatBackendErrors(error.response.data.errors || {});
        }
        this.$toasted.global.error({
          message: "Erreur lors du calcul de la prime",
        });
      } finally {
        this.isLoading = false;
      }
    },

    // ============================================
    // RÉDUCTION
    // ============================================
    onReductionInput() {
      if (
        this.reductionPercentage &&
        this.reductionPercentage.toString().startsWith("0")
      ) {
        this.reductionPercentage = this.reductionPercentage
          .toString()
          .replace(/^0+/, "");
      }
      if (this.reductionPercentage > 100) {
        this.reductionPercentage = 100;
      }
      this.clearFieldError("pourcentage_reduction");
    },

    async applyReduction() {
      if (!this.reductionPercentage || this.reductionPercentage <= 0) {
        this.$toasted.global.error({ message: "Entrez un pourcentage valide" });
        return;
      }
      if (this.reductionPercentage > 100) {
        this.$toasted.global.error({
          message: "Le pourcentage ne peut pas dépasser 100%",
        });
        return;
      }
      if (this.isApplyingReduction) return;
      this.isApplyingReduction = true;
      try {
        this.form.data.pourcentage_reduction = this.reductionPercentage;
        const response = await axios.post(
          api("assurances/automobile/apply-reduction"),
          {
            product_id: this.form.product_id || 1,
            data: this.form.data,
            pourcentage_reduction: this.reductionPercentage,
          }
        );
        if (response.data?.status === true && response.data?.data) {
          const result = response.data.data;
          const breakdown = result.breakdown || {};
          this.summary.net_premium = result.net_premium || 0;
          this.summary.rc_amount = breakdown.prime_rc || result.rc_amount || 0;
          this.summary.rc_amount_original =
            breakdown.prime_rc_original || result.rc_amount_original || 0;
          this.summary.guarantees_price =
            breakdown.garanties || result.garanties_price || 0;
          this.summary.avenant = result.avenant || 0;
          this.summary.tax = result.tax || 0;
          this.summary.total = result.total || 0;
          this.summary.reduction =
            breakdown.reduction || result.reduction || this.reductionPercentage;
          this.summary.garanties =
            breakdown.garanties || result.garanties_price || 0;
          this.breakdown = breakdown;
          this.form.amount = result.total || 0;
          this.form.per = this.reductionPercentage;
          this.hasReduction = true;
          this.$forceUpdate();
          this.$toasted.global.all({
            message: `Réduction de ${this.reductionPercentage}% appliquée`,
          });
        } else {
          this.$toasted.global.error({
            message: response.data?.error || "Erreur lors de l'application",
          });
        }
      } catch (error) {
        console.error("Erreur réduction:", error);
        if (error.response?.status === 422) {
          this.formatBackendErrors(error.response.data.errors || {});
        } else {
          this.$toasted.global.error({ message: "Une erreur est survenue" });
        }
      } finally {
        this.isApplyingReduction = false;
      }
    },

    async cancelReduction() {
      if (this.isApplyingReduction) return;
      this.isApplyingReduction = true;
      try {
        this.form.data.pourcentage_reduction = null;
        this.form.per = "";
        this.reductionPercentage = "";
        this.hasReduction = false;
        await this.calculatePremium();
        this.$toasted.global.all({ message: "Réduction annulée" });
      } catch (error) {
        console.error("Erreur annulation:", error);
        this.$toasted.global.error({ message: "Erreur lors de l'annulation" });
      } finally {
        this.isApplyingReduction = false;
      }
    },

    // ============================================
    // NAVIGATION
    // ============================================
    titleStep() {
      if (this.step === 1) {
        return "Informations (Étape 1/2)";
      } else if (this.step === 2) {
        return "Informations (Étape 2/2)";
      } else if (this.step === 3) {
        return "Fichiers joints";
      } else {
        return "Résultat";
      }
    },

    nextStep() {
      if (this.step < 4) {
        this.step++;
        this.form.step = this.step;
        if (this.step === 4) {
          this.calculatePremium();
        }
      }
      if (this.step === 3 && this.$refs.upload) {
        this.$refs.upload.reloadView();
      }
    },

    prevStep() {
      if (this.step === 2 && this.form.data.category_id != 4) {
        this.form.data.list_of_guarantees = [];
      }
      if (this.step === 3 && this.$refs.upload) {
        this.$refs.upload.reloadView();
      }
      if (this.step > 1) {
        this.step--;
        this.form.step = this.step;
      }
    },

    getButtonText() {
      const texts = {
        1: "Suivant",
        2: "Suivant",
        3: "Suivant",
        4: "Ajouter au panier",
      };
      return texts[this.step] || "Suivant";
    },

    // ============================================
    // SAUVEGARDE
    // ============================================
    async saveAssurance() {
      if (this.isLoading) return;
      if (this.step === 4) {
        this.addBasket();
        return;
      }
      if (!this.validateForm()) {
        this.$toasted.global.error({
          message: "Veuillez corriger les erreurs du formulaire",
        });
        return;
      }
      try {
        this.isLoading = true;
        this.form.amount = this.summary.total;
        const response = await axios.post(
          api("assurances/automobile/calculate"),
          {
            product_id: this.form.product_id || 1,
            data: this.form.data,
            step: this.step,
            amount: this.summary.total,
          }
        );
        if (response.data?.status) {
          const data = response.data.data || response.data;
          this.summary = {
            net_premium: data.net_premium || 0,
            rc_amount: data.breakdown?.prime_rc || data.rc_amount || 0,
            rc_amount_original:
              data.breakdown?.prime_rc_original ||
              data.rc_amount_original ||
              data.rc_amount ||
              0,
            guarantees_price:
              data.breakdown?.garanties || data.guarantees_price || 0,
            cedeao: data.cedeao || 0,
            avenant: data.avenant || 0,
            police_fees: data.breakdown?.frais_police || data.police_fees || 0,
            tax_rate: data.tax_rate || 0,
            tax: data.tax || 0,
            total: data.total || 0,
            reduction: data.breakdown?.reduction || data.reduction || 0,
            garanties: data.breakdown?.garanties || data.guarantees_price || 0,
          };
          this.form.amount = this.summary.total;
          if (data.prc) {
            this.form.data.originalPrc = data.prc;
          }
          this.errors = {};
          if (this.step === 1) {
            await this.getGuarantees();
            this.nextStep();
          } else {
            this.nextStep();
          }
        }
      } catch (error) {
        if (error.response?.status === 422) {
          this.formatBackendErrors(error.response.data.errors || {});
        } else {
          this.$toasted.global.error({
            message: "Erreur lors de la sauvegarde",
          });
        }
      } finally {
        this.isLoading = false;
      }
    },

    // ============================================
    // PANIER
    // ============================================
    addBasket() {
      if (this.$store.state.upload.files.length > 0) {
        const loader = this.$loading.show({
          container: null,
          canCancel: false,
          color: "#4B4B4B",
          backgroundColor: "#4B4B4B",
          height: 35,
          width: 35,
          loader: "bars",
          opacity: 0.3,
        });
        let form = new FormData();
        this.$store.state.upload.files.map((file, key) => {
          form.append("files[" + key + "]", file);
        });
        axios
          .post(api("administration/file/upload"), form, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            loader.hide();
            if (response.data.status) {
              this.files = response.data.files;
              this.addToCartWithFiles();
            } else {
              this.$toasted.global.error();
            }
          })
          .catch((error) => {
            loader.hide();
            this.$toasted.global.error({
              message: "le fichier choisi est trop volumineux",
            });
          });
      } else {
        this.addToCartWithFiles();
      }
    },

    addToCartWithFiles() {
      const productData = {
        ...this.form,
        amount: this.summary.total || 0,
        data: {
          use_type: this.form.data.use_type || null,
          client_name: this.form.data.client_name || null,
          client_firstname: this.form.data.client_firstname || null,
          client_phone: this.form.data.client_phone || null,
          client_email: this.form.data.client_email || null,
          type_engin: this.form.data.type_engin || "1",
          fuel_id: this.form.data.fuel_id
            ? parseInt(this.form.data.fuel_id)
            : null,
          power_id: this.form.data.power_id
            ? parseInt(this.form.data.power_id)
            : null,
          sale_code: this.form.data.sale_code || null,
          sale_point: this.form.data.sale_point || null,
          category_id: this.form.data.category_id
            ? parseInt(this.form.data.category_id)
            : null,
          sub_category_id: this.form.data.sub_category_id
            ? parseInt(this.form.data.sub_category_id)
            : null,
          use_type: this.form.data.use_type || null,
          semi_remorque: this.form.data.semi_remorque || false,
          domage: this.form.data.domage || false,
          first_six_month: this.form.data.first_six_month || null,
          duration_of_insurance: this.form.data.duration_of_insurance || null,
          number_of_seats: this.form.data.number_of_seats || "0",
          pourcentage_reduction: this.form.data.pourcentage_reduction || null,
          originalPrc: this.form.data.originalPrc || 0,
          valeur_venal: this.form.data.valeur_venal || "0",
          valeur_neuve: this.form.data.valeur_neuve || "0",
          list_of_guarantees: this.form.data.list_of_guarantees || [],
          contain_cedeao: this.form.data.contain_cedeao || false,
          prc:
            this.summary.rc_amount ||
            this.form.data.prc ||
            this.summary.breakdown?.prime_rc ||
            0,
          name: null,
          email: null,
          address: null,
          phone: null,
          person_to_contact: null,
          telephone_number: null,
          vehicle_registration_card: null,
          num_quittance: null,
          num_police: null,
          pricing: {
            amount: this.summary.net_premium || this.summary.amount || 0,
            avenant: this.summary.avenant || 0,
            taxe: this.summary.tax || 0,
            fees: this.summary.police_fees || 0,
            total: this.summary.total || 0,
            reduction: this.summary.reduction || 0,
            garanties: this.summary.garanties || 0,
            net_premium: this.summary.net_premium || this.summary.amount || 0,
            rc_amount: this.summary.rc_amount || 0,
            rc_amount_original: this.summary.rc_amount_original || 0,
            guarantees_price: this.summary.guarantees_price || 0,
            cedeao: this.summary.cedeao || 0,
            police_fees: this.summary.police_fees || 0,
            tax_rate: this.summary.tax_rate || 0,
            guarantees: this.guaranteesSummary || [],
            avenants: this.avenantsList || [],
            surprimes: this.surprimeList || [],
            breakdown: {
              prime_rc: this.summary.rc_amount || 0,
              prime_rc_original: this.summary.rc_amount_original || 0,
              garanties: this.summary.garanties || 0,
              cedeao: this.summary.cedeao || 0,
              avenant: this.summary.avenant || 0,
              frais_police: this.summary.police_fees || 0,
              taxe: this.summary.tax || 0,
              reduction: this.summary.reduction || 0,
            },
          },
        },
      };

      const cartItem = {
        product: productData,
        detail: {
          ...this.summary,
          guarantees: this.guaranteesSummary || [],
          avenants: this.avenantsList || [],
          surprimes: this.surprimeList || [],
          breakdown: this.breakdown || null,
        },
        files: this.files || [],
        check: true,
        uuids: this.$uuid(),
      };

      let carts = this.$storage.getItem("carts");
      if (carts) {
        let data = JSON.parse(this.$storage.decryptString(carts));
        data.push(cartItem);
        this.$storage.setItem(
          "carts",
          this.$storage.encryptString(JSON.stringify(data))
        );
      } else {
        const products = JSON.stringify([cartItem]);
        this.$storage.setItem("carts", this.$storage.encryptString(products));
      }

      this.$toasted.global.all({ message: "Le produit est ajouté au panier" });
      setTimeout(() => {
        this.$router("/pannier");
      }, 500);
    },

    // ============================================
    // NÉGOCIATION
    // ============================================
    saveNegotiated() {
      if (this.step !== 4) return;
      const loader = this.$loading.show({
        container: null,
        canCancel: false,
        color: "#4B4B4B",
        backgroundColor: "#4B4B4B",
        height: 35,
        width: 35,
        loader: "bars",
        opacity: 0.3,
      });
      this.form.amount = this.summary.total;
      axios
        .post(api("subscription/negotiated"), this.form)
        .then((response) => {
          if (response.data?.status) {
            const content = response.data;
            this.uuid = content.uuid;
            this.id = content.id;
            this.showComments();
            this.$document("#comments").modal("show");
          } else {
            this.$toasted.global.error();
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          if (error.response?.status === 422) {
            this.formatBackendErrors(error.response.data.errors || {});
          } else {
            this.$toasted.global.error({
              message:
                "Vous devez vous connecter pour procéder à cette opération",
            });
          }
        });
    },

    sendComment() {
      if (!this.comment.message) return;
      this.comment.uuid = this.uuid;
      this.comment.id = this.id;
      axios
        .post(api("subscription/add/message"), this.comment)
        .then(() => {
          this.comment.message = "";
        })
        .catch((error) => {
          console.error("Erreur envoi message:", error);
        });
    },

    closeModal() {
      this.$document("#comments").modal("hide");
      setTimeout(() => {
        window.location.reload();
      }, 200);
    },

    showComments() {},
    showTooltips(text) {
      this.$document(".tooltips_n").tooltip({
        title: text,
        trigger: "click",
        placement: "top",
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../.././../css/auto-insurance.css";
</style>